module.exports = new __parcel__URL__("galaga.926721b8.jpg").toString();